import React from 'react';

import { useAuth } from '@/src/app/context/useAuth';
import { Container } from '@/src/ui';
import { Constants } from '@/src/utils';
import SuperAdminDashboard from './superAdmin/SuperAdminDashboard';
import TeacherDashboard from './teacher/TeacherDashboard';
import StudentDashboard from './student/StudentDashboard';
import DistrictAdminDashboard from './districtAdmin/DistrictAdminDashboard';
import SchoolAdminDashboard from './schoolAdmin/SchoolAdminDashboard';

const DashboardPage: React.FC = () => {
    document.title = 'Dashboard';
    const { user } = useAuth();

    function renderDashboard() {
        const roles = Constants.ROLES;
        const userRole = user?.role || '';
        switch (userRole) {
            case roles.SUPER_ADMIN:
                return <SuperAdminDashboard />;
            case roles.DISTRICT_ADMIN:
                return <DistrictAdminDashboard />;
            case roles.SCHOOL_ADMIN:
                return <SchoolAdminDashboard />;
            case roles.TEACHER:
                return <TeacherDashboard />;
            case roles.STUDENT:
                return <StudentDashboard />;
            default:
                return <div>Welcome! Here is your dashboard.</div>;
        }
    }

    return (
        <div style={{ overflowX: 'hidden' }}>
            <Container fullWidth style={{ maxWidth: '100%' }}>
                {renderDashboard()}
            </Container>
        </div>
    );
};

export default DashboardPage;
